import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";


const GeneratedInvoice = ({ children }) => { 

    let vendor, eedetails, aendetails, pagedata, invoice=[], total_data;
    let timestamp =new Date() ;

  return (
    <>
      <div className="page" style={{ width: "21.1cm", height: "29.7cm", background: "white", boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)", border: "0px solid #000" }}>
      <div className="subpage" style={{ paddingLeft: "0.8cm", paddingRight: "0.8cm" }}>
        <table style={{ marginTop: "17px" }}>
          <tbody>
            <tr>
              <td colSpan="7">GSTIN NO: _______________________________</td>
            </tr>
            <tr>
              <td colSpan="7" style={{ fontSize: "20px", textAlign: "center" }}>
                {vendor?.full_name}
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan="7" style={{ borderBottom: "1px solid #000", textAlign: "center" }}>
                {vendor?.address}
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                Ref No. _______________________<br />
                The Executive Engineer<br />
                {eedetails?.name.replace("EE", "")}, JAIPUR<br />
                BILL NO :- {pagedata?.bill_prefix}-- _______<br />
                Dated- <br />
              </td>
              <td>&nbsp;</td>
              <td colSpan="3">
                <br />
                Date:- <br />
                {aendetails?.name.replace("AEN PHED ", "")}
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                Order No. ____________________________________<br />
              </td>
              <td>&nbsp;</td>
              <td colSpan="3">
                Period :  To <br />
              </td>
            </tr>
            <tr>
              <td colSpan="7">
                Transportation work of drinking water through tanker under the jurisdiction of SE, {pagedata?.company_name}
              </td>
            </tr>
          </tbody>
        </table>
        <table style={{ marginTop: "17px" }}>
          <thead>
            <tr>
              <td className="tddata">S.No</td>
              <td className="tddata" width="100">Date</td>
              <td className="tddata">Tanker travel Distance From 0 to 5 kms.</td>
              <td className="tddata">Tanker travel Distance From 5 to 10 kms.</td>
              <td className="tddata">Tanker travel Distance From above 10 Kms.</td>
              <td className="tddata">Total Trip</td>
            </tr>
          </thead>
          <tbody>
            {invoice.map((value, i) => (
              <tr key={i}>
                <td className="tddata1">{i + 1}</td>
                <td className="tddata1">{value.date}</td>
                <td className="tddata1">{value.under_5_km}</td>
                <td className="tddata1">{value.under_5_to_10}</td>
                <td className="tddata1">{value.above_10}</td>
                <td className="tddata1">{value.total_trip_per_day}</td>
              </tr>
            ))}
            <tr>
              <td className="tddata1"></td>
              <td className="tddata1">Total : </td>
              <td className="tddata1">{total_data?.total_under_5_km}</td>
              <td className="tddata1">{total_data?.total_under_5_to_10}</td>
              <td className="tddata1">{total_data?.total_above_10}</td>
              <td className="tddata1">{total_data?.total_trip}</td>
            </tr>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>Total 0-5 Kms Amount </td>
              <td style={{ textAlign: "right" }}>{total_data?.total_under_5_km}X{total_data?.fare_under_5_km} =</td>
              <td style={{ textAlign: "right" }}>
                {total_data?.amount_under_5_km.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>Total 5-10 Kms Amount </td>
              <td style={{ textAlign: "right" }}>{total_data?.total_under_5_to_10}X{total_data?.fare_under_5_to_10} =</td>
              <td style={{ textAlign: "right" }}>
                {total_data?.amount_under_5_to_10.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>Total Above 10 Kms Amount </td>
              <td style={{ textAlign: "right" }}>{total_data?.total_above_10}X{total_data?.fare_above_10} =</td>
              <td style={{ textAlign: "right" }}>
                {total_data?.amount_above_10.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>Trip Total Amount </td>
              <td style={{ textAlign: "right" }}>=</td>
              <td style={{ textAlign: "right" }}>
                {total_data?.sub_total.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>TP {total_data?.tp_per}% {total_data?.tp_type}</td>
              <td style={{ textAlign: "right" }}>=</td>
              <td style={{ textAlign: "right" }}>
                {total_data?.tp_amount.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>
                <b>Grand Total (Payable) Amount </b>
              </td>
              <td style={{ textAlign: "right" }}>=</td>
              <td style={{ textAlign: "right" }}>
                <b>{total_data?.grand_total.toFixed(2)}</b>
              </td>
            </tr>
            <tr>
              <td colSpan="6" style={{ fontSize: "10px", textAlign: "center" }}>
                --- This is a system generated invoice and does not require any signature or stamp ---
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
};

export default GeneratedInvoice;
